import { render } from "./Reporting.vue?vue&type=template&id=5ad00134&scoped=true&lang=pug"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"

import "./Reporting.vue?vue&type=style&index=0&id=5ad00134&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad00134"]])

export default __exports__